import { Divider, Paper, Stack, Typography, useTheme } from '@mui/material'
import { ReactNode } from 'react'

interface Props {
  title?: string
  showTransactionSection?: boolean
  children: ReactNode
}

const SectionContainer = ({
  showTransactionSection = true,
  children,
}: Props) => {
  const theme = useTheme()

  if (!showTransactionSection) {
    return null
  }

  return (
    <Paper
      elevation={3}
      sx={{
        borderColor: theme.palette.divider,
        borderWidth: 1,
        borderStyle: 'solid',
        borderRadius: 2,
        padding: 20,
        marginTop: '1rem',
        p: 1,
        mb: 3,
      }}
    >
      <Typography variant="h5" component="div" gutterBottom>
        Transaction
      </Typography>
      <Stack
        direction={{ md: 'row', xs: 'column' }}
        divider={<Divider orientation="vertical" flexItem />}
        justifyContent="space-around"
        spacing={2}
      >
        {children}
      </Stack>
    </Paper>
  )
}

export default SectionContainer